import { ReactNode, createContext, useContext, useState, useCallback } from 'react';

type Toast = { id: string; message: string; tone?: 'neutral' | 'positive' | 'negative' };
type Ctx = { push: (t: Omit<Toast, 'id'>) => void };
const ToastCtx = createContext<Ctx | null>(null);

export function ToastProvider({ children }: { children: ReactNode }) {
  const [toasts, setToasts] = useState<Toast[]>([]);
  const push = useCallback((t: Omit<Toast, 'id'>) => {
    const id = Math.random().toString(36).slice(2);
    setToasts(s => [...s, { ...t, id }]);
    setTimeout(() => setToasts(s => s.filter(x => x.id !== id)), 4000);
  }, []);
  return (
    <ToastCtx.Provider value={{ push }}>
      {children}
      <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 space-y-1">
        {toasts.map(t => (
          <div key={t.id} className="bg-ink text-bg px-3 py-2 text-sm rounded-sm tracking-tight">
            {t.message}
          </div>
        ))}
      </div>
    </ToastCtx.Provider>
  );
}

export function useToast() {
  const c = useContext(ToastCtx);
  if (!c) throw new Error('Toast outside provider');
  return c;
}
